import React from 'react';
import { motion } from 'framer-motion';
import {
  Gift, Utensils, DoorOpen, Palette, Search, PartyPopper,
  Car, Calendar, Coffee, Baby, Heart, BookOpen,
} from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const ICON_MAP = {
  Gift, Utensils, DoorOpen, Palette, Search, PartyPopper,
  Car, Calendar, Coffee, Baby, Heart, BookOpen,
};

export default function RevenueSources() {
  const { t } = useLang();
  const rev = t.revenue;

  return (
    <section id="revenue" className="py-24 md:py-32 relative overflow-hidden" style={{ background: '#0F1115' }}>
      <div
        className="orb-purple absolute"
        style={{ width: 500, height: 500, top: '20%', right: '-5%', opacity: 0.07 }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-widest font-semibold">Revenue</span>
          </div>
          <h2 
            className="text-4xl md:text-6xl font-black text-white mb-4 font-heading leading-tight"
            style={{
              fontFamily: "'Sora', sans-serif",
              textShadow: '0 2px 30px rgba(0,0,0,0.5)'
            }}
          >
            {rev.title}
          </h2>
          <p className="text-[#BFC3C9] text-lg">{rev.subtitle}</p>
        </motion.div>

        {/* Revenue Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {rev.items.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || Gift;
            const isGold = i % 3 !== 2;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="glass rounded-xl p-5 flex flex-col items-center text-center gap-3 card-lift group cursor-default"
                data-testid={`revenue-item-${i}`}
              >
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                  style={{
                    background: isGold ? 'rgba(212,175,55,0.08)' : 'rgba(107,78,255,0.08)',
                    border: `1px solid ${isGold ? 'rgba(212,175,55,0.2)' : 'rgba(107,78,255,0.2)'}`,
                  }}
                >
                  <Icon size={20} style={{ color: isGold ? '#D4AF37' : '#9B7FFF' }} />
                </div>
                <p className="text-white text-sm font-medium leading-snug">{item.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
